export default "__VITE_ASSET__1efe1e05__"